module.exports = __webpack_public_path__ + "img/14.41f56c18.png";